import { ReactElement, ReactNode } from 'react'

import styled from '@emotion/styled'

import { BaseCell, InteractiveCell, PushCell } from '@cash-design-system/react'
import { ProgressCircle } from '@cash-web/shared/ui-progress-circle'

const Container = styled.div`
  width: 3rem;
  height: 3rem;
`

function ProgressCellCircle({
  progressPercent,
  centerContent,
}: {
  progressPercent: number
  centerContent?: ReactNode
}) {
  const totalProgressCircleWidth = 48
  const strokeWidth = 4
  const radius = (totalProgressCircleWidth - strokeWidth) / 2

  return (
    <Container>
      <ProgressCircle progressPercent={progressPercent} strokeWidthAsPercentageOfRadius={strokeWidth / radius}>
        {centerContent}
      </ProgressCircle>
    </Container>
  )
}

export function ProgressCell({
  label,
  body,
  accessory,
  progressContent,
  progressPercent,
}: {
  label: string
  body?: ReactNode
  accessory?: ReactElement
  progressContent: ReactNode
  progressPercent: number // 0 to 1
}) {
  return (
    <BaseCell
      label={label}
      body={body}
      accessory={accessory}
      asset={{
        avatar: <ProgressCellCircle progressPercent={progressPercent} centerContent={progressContent} />,
      }}
    />
  )
}

export function ProgressCellInteractive({
  label,
  body,
  accessory,
  progressContent,
  progressPercent,
  onClick,
}: {
  label: string
  body?: ReactNode
  accessory?: ReactElement
  progressContent: ReactNode
  progressPercent: number // 0 to 1
  onClick: () => void
}) {
  return (
    <InteractiveCell
      label={label}
      onClick={onClick}
      cellProps={{
        body,
        accessory,
        asset: {
          avatar: <ProgressCellCircle progressPercent={progressPercent} centerContent={progressContent} />,
        },
      }}
    />
  )
}

export function ProgressPushCell({
  label,
  body,
  progressContent,
  progressPercent,
  onClick,
}: {
  label: string
  body?: ReactNode
  accessory?: ReactElement
  progressContent: ReactNode
  progressPercent: number // 0 to 1
  onClick: () => void
}) {
  return (
    <PushCell
      label={label}
      onClick={onClick}
      cellProps={{
        body,
        asset: {
          avatar: <ProgressCellCircle progressPercent={progressPercent} centerContent={progressContent} />,
        },
      }}
    />
  )
}
